import axios from 'axios'
import { URL } from '../url'

export default async function getCase (id) {
  const response = await axios.get(URL + '/confluence/pages/' + id.toString())
  return response
}
